import angular from 'angular'

import component from './cookies-consent.component'

let module = angular.module('cookiesConsent', [])

.component('cookiesConsent', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/cookies-consent/index.js